import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { DeviceComparisonStatus, DeviceProfileService, IDeviceParameterComparisonResult } from "@app/services/device-profile.service";
import './device-profile-comparison-status-label.component.scss';

@Component({
    selector: 'device-profile-comparison-status-label',
    template: require('./device-profile-comparison-status-label.component.html')
})
export class DeviceProfileComparisonStatusLabelComponent implements OnInit, OnChanges {

    @Input() comparisonResult: IDeviceParameterComparisonResult;

    status: DeviceComparisonStatus;

    DeviceComparisonStatus = DeviceComparisonStatus;

    constructor(
        private readonly deviceProfileService: DeviceProfileService
    ) { }

    ngOnInit() {
        this.render();
    }

    ngOnChanges() {
        this.render();
    }

    // ---

    private render(): void {
        this.status = this.deviceProfileService.getDeviceParameterComparisonResultStatus(this.comparisonResult);
    }

}
